// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Lm0","type":"styles_type__236f2","choices":"styles_choices__3Js1m"};